import { Component, ViewContainerRef, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, skip, map } from 'rxjs/operators';
import { NgProgress } from 'ngx-progressbar';
import { Observable, Subscription, interval } from 'rxjs';

import { AlertController, LoadingSpinner } from 'mm-ui';
import { ViewportScroller } from '@angular/common'

import { ColorsState } from './stores/colors.state';
import * as myGlobals from './utils/globals';
import { LoggedUser } from './models/loggedUser.service';
import { MediaService } from './components/media/media.service';
import { HomepageColorsService } from './services/homepageColors.service';
import { ContentService } from './components/cms/content/content.service';
import { Homepage } from './models/homepage';
import { UserInterface } from './interfaces/userInterface';
import { PendentItemsState } from './stores/pendentItems.state';
import * as PendentActions from './actions/pendentItems.actions';
import { NotifyService } from './services/notify.service';
import { isOnLogin } from './utils/utils';
import { LoginService } from './components/login/login.service';
import { LanguageService } from './services/language.service';
import { FontFamilyService } from './services/fontFamily.service';
import { NavigationService } from './services/navigation.service';
import { EventsService } from './services/events.service';
import { ChatService } from './components/chat/chat.service';
import { PlatformConfigService } from './components/platform-config/platform-config.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'n-cms';
  progressColor = '#ff5e3a';

  show_menu = myGlobals.show_menu;
  navbar_items = myGlobals.navbar_items;
  showCM: boolean = myGlobals.showContentMenu;
  hide_breadcrumb: boolean = false;
  showAppBar: boolean = false;
  mediaUrl: string;
  userInfo: any;
  colors: any[] = [];
  colorSelected: string;
  selectedPageId: string;
  homePage$: Observable<Homepage>;
  logged;
  userHasConfigPermission: boolean;
  user: UserInterface;
  notifys: number;
  token: string;
  totalNotifications$: Subscription;
  readedBellNotifications$: Subscription;
  bellNotifications$: Subscription;
  private notifyEventsSubscription: Subscription;
  notifyConnected: boolean;
  nots = {
    activities: 0,
    default: 0
  };
  chatNots = {
    activities: 0,
    default: 0
  }

  message: any;
  hasAccess: boolean;
  showHomepagesOnNavbar = false;

  private listenerCopy = () => { }
  private listenerCtxMenu: () => void = () => { };
  private listenerPtrscr: () => void = () => { };
  event: boolean = true;


  intervalSubscription: any;
  isNewVersionAvailable: boolean = false;
  cms: any


  constructor(
    public vcr: ViewContainerRef,
    private alertController: AlertController,
    private loadingSpinner: LoadingSpinner,
    private viewportScroller: ViewportScroller,
    private store: Store<ColorsState>,
    private _ColorService: HomepageColorsService,
    private _pendentStore: Store<PendentItemsState>,
    private mediaService: MediaService,
    private router: Router,
    private _contentService: ContentService,
    private notifyService: NotifyService,
    private _loginService: LoginService,
    private _user: LoggedUser,
    public ngProgress: NgProgress,
    private _fontService: FontFamilyService,
    private eventsService: EventsService,
    private _language: LanguageService,
    private chatSerivce: ChatService,
    private _platformConfig: PlatformConfigService,
    private messageService: MessageService,
    private translate: TranslateService,
    private _renderer2: Renderer2,
    private navigationService: NavigationService
  ) {

    this.alertController.setViewContainerRef(vcr);
    this.loadingSpinner.setViewContainerRef(vcr);
    this.navigationService.setCmsMenuItems(myGlobals.menu_items);

    this.getColorChange();
    this.getLanguage();
    this.getFontFamily();
    this.setGoogleAnalyticsEvent();

    this.cms = JSON.parse(localStorage.getItem('cms'));

    this.router
      .events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setNavbarHidden(event);
        this.subscribeToUserChange();
        this.getLanguage();
        this.getFontFamily();


        if (this.listenerCopy) {
          this.listenerCopy();
        }
        if (this.listenerCtxMenu) {
          this.listenerCtxMenu();
        }
        if (this.listenerPtrscr) {
          this.listenerPtrscr();
        }
      });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.viewportScroller.scrollToPosition([0, 0]);
        let cms = localStorage.getItem('cms');
        let parsed = JSON.parse(cms);
        if (parsed && parsed.homepageDefinition)
          gtag('config', parsed.homepageDefinition.googleMonitoringCode, { 'page_path': event.urlAfterRedirects });
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {

        this.once(this.event, event)

      });

  }

  ngOnInit() {

    this.getColorsFromRedux();
    this.getFontFamily();
    this.subcribeToUserProfileChange();
    // this.appService.changeFavicon('assets/favicon/32x32.png');
    this.homePage$ = this._contentService.getHomepageObj();
    this.logged = this._user.isAuthenticated();
    this.user = this._user.getUser() && this._user.getUser().user;
    this.token = localStorage.getItem('accessToken');
    this.configAuthTimeout();
    // this.subscribeToUserChange();
    this.validadeModulesEnabled(this.user);
    this.connectLoginWebsocket();

    if (this._user.isAuthenticated()) {
      this.mediaService.getIamToken().subscribe();
    }

  }

  showUpdatePopup() {
    // Cria o fundo escuro para bloquear interações
    const overlay = document.createElement('div');
    overlay.id = 'update-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.background = 'rgba(0, 0, 0, 0.5)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';

    // Cria a caixa de mensagem
    const modal = document.createElement('div');
    modal.style.background = '#fff';
    modal.style.padding = '20px';
    modal.style.borderRadius = '10px';
    modal.style.textAlign = 'center';
    modal.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)';
    modal.innerHTML = `
      <h2>Atualização Disponível</h2>
      <p>Uma nova versão do aplicativo está sendo instalada.</p>
      <p>Por favor, aguarde...</p>
    `;

    // Adiciona os elementos ao corpo da página
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }


  convertBase64ToBlob(base64Image: string) {
    const parts = base64Image.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const decodedData = window.atob(parts[1]);
    // so deus sabe pq tava quebrando quando baixa esse mimetype
    const uInt8Array = new Uint8Array(imageType === 'application/vnd.ms-excel.sheet.macroenabled.12' ? decodedData.length - 1 : decodedData.length);

    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: imageType });
  }






  once(evt, e) {
    if (evt) {
      if (!e.url.includes("/login")) {
        this.listenToNotifyEvents();
        this.listenToChatEvents();
        this.getReadedBellNotifications();
        this.getUnreadedBellNotifications();
        this.getReadedChatMessages();
        this.getBellDefaultNotifys();
        this.getBellActivitiesNotifys();
        this.event = false
      }
    } else {
      if (e.url.includes("/login"))
        this.event = true
    }
  }

  blockFunctions() {

    this._platformConfig.getBlockCopy().subscribe({
      next: resp => {

        if (resp.blockCopy) {

          this.listenerCtxMenu = this._renderer2.listen('document', 'contextmenu', event => {
            event.stopPropagation();
            event.preventDefault();
            this.setMessage('error', this.translate.instant('errors.interactionBlocked'), '')
          })

          this.listenerCopy = this._renderer2.listen('document', 'keydown', event => {
            if ((event.ctrlKey || event.metaKey) && (event.key === 'c' || event.key === 'C')) {
              event.stopPropagation();
              event.preventDefault();
              this.setMessage('error', this.translate.instant('errors.interactionBlocked'), '')
            }
          })

          this.listenerPtrscr = this._renderer2.listen('window', 'keydown', event => {
            if (event.key === 'PrtScr' || (event.metaKey && event.shiftKey && (event.key === 's' || event.key === 'S'))) {
              event.stopPropagation();
              event.preventDefault();
              this.setMessage('error', this.translate.instant('errors.interactionBlocked'), '')
            }
          })
        }
      },
      error: err => {
        console.log({ blockCopyError: err })
      }
    });
  }

  getReadedChatMessages() {
    const hasModule = this._user.getModules().includes('chat');

    if (hasModule) {
      this.chatSerivce.getUnreadedMessages().subscribe(({ unreadedMessages }: any) => {
        if (unreadedMessages) {
          this.chatNots.default = unreadedMessages;
        }
      });
    }
  }

  getUnreadedBellNotifications() {
    this.totalNotifications$ = this.notifyService.getBellNotify().subscribe((total: any) => {
      if (total) {
        this.nots.default = total;
      }
    });
  }

  getReadedBellNotifications() {
    this.readedBellNotifications$ = this.notifyService.getReadBellNotification().subscribe((id: any) => {
      if (id != 'all' && this.nots.default > 0) {
        this.nots.default--;
      } else if (id == 'all' && this.nots.default > 0) {
        this.nots.default = 0
      }
    });
  }

  listenToNotifyEvents() {
    if (this.notifyEventsSubscription) {
      return;
    }
    this.notifyEventsSubscription = this.notifyService
      .getSocketNotifys()
      .subscribe(() => this.nots.default++);
  }

  listenToChatEvents() {
    this.eventsService.listenToChatMessage()
      .pipe(
        map(raw => {
          if (raw?.type || raw?.message) {
            return raw;
          }
          try {
            return typeof raw?.data === 'string' ? JSON.parse(raw.data) : raw?.data;
          } catch {
            return raw;
          }
        }),
        filter(message => {
          const userId = this._user.getUserId();
          const chatMessage = message?.message ?? message;
          const senderId = chatMessage?.user?.userId;
          const isChatMessage = message?.type === 'MESSAGE' || !!message?.message || !!chatMessage?.roomId;

          return isChatMessage && !!senderId && senderId !== userId;
        })
      ).subscribe(() => this.chatNots.default++);
  }

  subscribeToUserChange() {

    // this._user.subscribeUserChange$().pipe(take(1)).subscribe(user => {
    //   console.log('subscribeToUserChange');
    this.validadeModulesEnabled(this.user);

    // })
  }

  connectLoginWebsocket() {
    if (!isOnLogin()) {
      this._loginService.connectEventSource();
    }
  }

  validadeModulesEnabled(user?: any) {
    this._user.getModules();
  }

  configAuthTimeout() {
    this._loginService.listenToUserInterection();
    if (this._user.isAuthenticated()) {
      let accessToken = this._user.getToken();
      this._loginService.setAuthTimeout({ accessToken });
    }
  }

  // getTotalNotifications(): void {
  //   this.bellNotifications$ = this.notifyService.getBellNotify().subscribe((value: number) => this.notifys = value)
  // }

  getBellActivitiesNotifys() {
    this.notifyService.getBellActivitiesNotify().subscribe(total => this.nots.activities = total);
  }


  getBellDefaultNotifys() {
    this.notifyService.getBellDefaultNotify().subscribe(total => this.nots.default = total);
  }

  subcribeToUserProfileChange() {
    this._user.subscribeUserChange$().pipe(skip(1)).subscribe((user: UserInterface) => {
      this.user = { ...this.user, ...user };
      this.token = localStorage.getItem('accessToken');
      this.validateLoggedUser(this._user.isAuthenticated());
    });
  }

  validateUserHasConfigPermission() {
    if (this._user.isAuthenticated()) {
      this.userHasConfigPermission = this._user.checkRole('UP_PLUS');
    }
  }

  logout() {
    this._pendentStore.dispatch(new PendentActions.ResetCreatePage);
    this._pendentStore.dispatch(new PendentActions.ResetCreateUser);
    this._pendentStore.dispatch(new PendentActions.ResetDefineHomepage);
    this.notifyService.cancelAlreadyOpenAll();

    let clientid = this._user.getClientId();
    let modeAuth = this._user.getDecodedToken().modeAuth;
    let auth = '';

    if (modeAuth == 'ACTIVE_DIRECTORY') {
      auth = 'ad';
    } else if (modeAuth == 'GOOGLE') {
      auth = 'google';
    } else if (modeAuth == 'OFFICE_365') {
      auth = 'office';
    } else if (modeAuth == 'ADFS') {
      auth = 'adfs';
    } else if (modeAuth == 'MANUAL') {
      auth = "manual";
    } else if (modeAuth == 'OKTA') {
      auth = "okta";
    } else if (modeAuth == 'X509') {
      auth = 'all'
    }

    this._loginService.signout().subscribe(() => {
      if (clientid) {
        this.router.navigate([`/login${auth ? `/${auth}` : ''}`], { queryParams: { clientid, signedOut: 'true' } });
      } else {
        this.router.navigate([`/login${auth ? `/${auth}` : ''}`], { queryParams: { signedOut: 'true' } });
      }
    });

    this.listenerCopy();
    this.listenerCtxMenu();
    this.listenerPtrscr();

  }


  getColorsFromRedux() {
    this.store.select('colors').subscribe(colorsArray => {
      if (colorsArray) {
        this.colors = colorsArray['colors'];
      }

      let colorsId = this.colors.map(color => color.id);
      let selectedColor = this.colors.filter(color => color['selected']).map(color => color.id);
      if (selectedColor.length > 0) {
        this._ColorService.setColor(selectedColor[0]);
        this.colorSelected = selectedColor[0];
      } else if (colorsId.indexOf(this.colorSelected) == -1) {
        this._ColorService.setColor(colorsId[0]);
        this.colorSelected = colorsId[0];
      }

      this.validateUserHasConfigPermission();
    });
  }

  setNavbarHidden(event: NavigationEnd): void {
    const hiddenRoutes = [
      '/login',
      '/chat',
      '/lms',
      '/lms-2.0',
      '/modules/lms-2.0',
      '/modules/gamification-2.0',
      '/validate',
      '/newlogin',
      'set_password',
      '/chats',
      'email-reset'
    ];

    const urlPath = event.url.split('?')[0];
    const shouldHide =
      urlPath === '/' ||
      hiddenRoutes.some(route => {
        if (route === '/lms') {
          return /^\/lms(\/|$)/.test(urlPath);
        }
        if (route === '/lms-2.0') {
          return /^\/lms-2\.0(\/|$)/.test(urlPath);
        }
        if (route === '/modules/lms-2.0') {
          return /^\/modules\/lms-2\.0(\/|$)/.test(urlPath);
        }
        if (route === '/modules/gamification-2.0') {
          return /^\/modules\/gamification-2\.0(\/|$)/.test(urlPath);
        }
        return urlPath.includes(route);
      });

    this.showAppBar = !shouldHide;
    this.hasAccess = !!localStorage.getItem('accessToken');

    if (this.showAppBar) {
      this.blockFunctions();
      this.validateShowHomepagesOnNavbar();
    }

    if (event.url.includes('/hp/page/')) {
      this.setActivePage(event.url);
    } else {
      this.selectedPageId = '';
    }

    this.validateLoggedUser(this.hasAccess);
  }

  validateShowHomepagesOnNavbar() {
    this._platformConfig.getShowHomepagesOnNavbar().subscribe({
      next: ({ showHomepagesOnNavbar }) => {
        this.showHomepagesOnNavbar = showHomepagesOnNavbar;
        localStorage.setItem('showHomepagesOnNavbar', showHomepagesOnNavbar);
      },
      error: (_) => { }
    })
  }

  validateLoggedUser(access) {

    if (this.showAppBar && !!access) {
      let media = this.user.photo;


      if (media && media.mediaId) {
        this.getPhoto(media.mediaId);
      }
      this.userInfo = this._user.getToken();
      this.getReadedChatMessages();
    }

  }

  setActivePage(url: string) {
    let pageId = url.replace('/hp/page/', '').split('?')[0];
    this.selectedPageId = pageId;
  }

  // getPhoto(mediaId) {
  //   this.mediaService
  //     .getPhoto(mediaId)
  //     .subscribe((media: any) => {
  //       this.mediaUrl = media.url;
  //     });
  // }

  getPhoto(mediaId) {
    this.mediaService.getMedia(mediaId).subscribe((media: any) => this.mediaUrl = media.url_thumbnail);
  }
  setColor(id: string) {
    this.colorSelected = id;
    this._ColorService.setColor(id);
    this._ColorService.updateColors(this.colors.map(color => {
      let newColor = { ...color };
      if (color.id == this.colorSelected) {
        newColor['selected'] = true;
      } else {
        newColor['selected'] = false;
      }
      return newColor;
    }));
  }

  getColorChange() {
    // this.strore.pipe(filter(colors => colors.colors.length>0)).subscribe(colors => colors.colors[0].first ? console.log(this.ngProgress.config.color) : null)
  }

  getFontFamily(): void {
    let localCms = localStorage.getItem('cms');
    let cms = JSON.parse(localCms);
    if (cms.homepageDefinition !== undefined && cms.homepageDefinition.customFontUrl !== "" &&
      cms.homepageDefinition.customFontUrl !== null && cms.homepageDefinition.customFontUrl !== undefined) {
      this._fontService.setFontFamily(cms.homepageDefinition.customFontUrl);
    }
  }

  getLanguage(): void {

    const cms = localStorage.getItem('cms');
    let parsed = JSON.parse(cms);
    if (parsed.homepageDefinition !== undefined) {
      this._language.getLanguage(parsed.homepageDefinition.language);
    } else {
      this._language.getLanguage("pt-Br");
    }

  }

  setGoogleAnalyticsEvent(): void {
    let cms = localStorage.getItem('cms');
    let parsed = JSON.parse(cms);

    if (parsed.homepageDefinition && parsed.homepageDefinition.googleMonitoringCode) {
      let gtagScript: HTMLScriptElement = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${parsed.homepageDefinition.googleMonitoringCode}`;
      document.head.prepend(gtagScript);
      gtag('config', parsed.homepageDefinition.googleMonitoringCode, { send_page_view: true });
    }

  }

  setMessage(severity: string, summary: string, detail: string): void {
    this.messageService.add({ severity, summary, detail })
  }

}
